var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductCreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-331",
    d: "M73.31,403.17,32.67,379.71c-2.29-1.32-2.29-3.47,0-4.79L269.06,238.44a9.19,9.19,0,0,1,8.3,0L318,261.9c2.29,1.33,2.29,3.47,0,4.79L81.61,403.17A9.13,9.13,0,0,1,73.31,403.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-331",
    d: "M441.55,314.06l-73.53-42a4.79,4.79,0,0,0-4.33,0l-.76.44c-1.2.69-1.19,1.79,0,2.47L388,289l-25.63,14.79L337.6,289.52a4.79,4.79,0,0,0-4.33,0l-.76.44a1.32,1.32,0,0,0,0,2.5l74.77,43.16.81-1,.4.23,29.51-17,.23.14.43-.52.63-.36-.22-.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.75,433.81a33.12,33.12,0,0,1-16.46-4c-.53-.31-1-.62-1.49-1L196.7,426l24-3.52,1.61-3.36L217,416l-22.49,3.28,1.1-3.12c1-2.91,3.43-5.5,6.94-7.5a33.3,33.3,0,0,1,16.19-3.86,39,39,0,0,1,7.13.65l73-42.16a9.34,9.34,0,0,1-.4-5.81c.82-3.26,3.3-6.15,7.19-8.36a35.9,35.9,0,0,1,32.68.15c.52.3,1,.62,1.48.95l4.1,2.89-24,3.51-1.61,3.36,5.34,3.13,22.48-3.28-1.1,3.12c-1,2.91-3.43,5.5-6.94,7.5a33.3,33.3,0,0,1-16.19,3.86,38.13,38.13,0,0,1-7.13-.66l-73,42.16a9.37,9.37,0,0,1,.4,5.82c-.82,3.26-3.3,6.15-7.19,8.36A33.32,33.32,0,0,1,218.75,433.81Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,335.31V312.67s-1.15-12.78-10.1-22.47-17-6.39-19.58-1.79,3.33,13.33,7.12,18.24C44,312.56,62,340,62,352.31Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62,335.31V312.67s-1.15-12.78-10.1-22.47-17-6.39-19.58-1.79,3.33,13.33,7.12,18.24C44,312.56,62,340,62,352.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62,331.73a.55.55,0,0,1-.54-.46c-4.09-24.69-22.87-41.64-23.06-41.8a.57.57,0,0,1,0-.79.54.54,0,0,1,.78,0c.2.17,19.27,17.36,23.42,42.45a.55.55,0,0,1-.45.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,344.93s.78-2.36-2.7-3-4.8-3.49-5.13-8.34-1.79-8.33-6.15-9.05-7.87,1.48-10.7-.7S31.05,316.42,25,318.82s-4.1,7.61-.93,11,4.09,4.51,1.67,10-.66,10.62,4.95,11.91,8.74.62,8.83,6.78.94,8.89,4,11.3,12.74,1.33,16.76,2.26a8.76,8.76,0,0,1,5.64,4.52Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,370.28a.46.46,0,0,1-.45-.32c-10.22-30.32-33.32-42.57-33.56-42.69a.49.49,0,0,1-.2-.65.48.48,0,0,1,.65-.2c.23.12,23.68,12.52,34,43.23a.49.49,0,0,1-.3.61A.47.47,0,0,1,65.88,370.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.23,343.86l-.1,0c-6.67-1.52-17.34-.7-17.45-.69a.48.48,0,0,1-.07-1c.44,0,10.92-.84,17.73.71a.48.48,0,0,1,.36.58A.49.49,0,0,1,51.23,343.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67,358.43c-3.05,0-6.28-.2-6.48-.21a.48.48,0,0,1-.45-.52.47.47,0,0,1,.51-.45c.07,0,7.52.47,10.43,0a.49.49,0,0,1,.55.4.48.48,0,0,1-.4.55A30.38,30.38,0,0,1,56.67,358.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,340.3h0a.48.48,0,0,1-.46-.5,36.76,36.76,0,0,1,2.15-10.16.48.48,0,0,1,.62-.27.49.49,0,0,1,.28.62,36.16,36.16,0,0,0-2.08,9.86A.49.49,0,0,1,48.1,340.3Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,75.72l-6.47,3.73a8.09,8.09,0,0,0,.06-.85V76.73c0-3.34-2.34-4.69-5.23-3a10,10,0,0,0-3.12,3c-.47-4.19-3.76-5.75-7.75-3.44a17.26,17.26,0,0,0-7.82,13.54v2.8a7.46,7.46,0,0,0,.66,3.25L102,96a6.4,6.4,0,0,0-2.9,5c0,1.85,1.3,2.6,2.9,1.67l35-20.22a6.42,6.42,0,0,0,2.89-5C139.93,75.55,138.64,74.8,137,75.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3,58.55l-3.57,1.37V52.06c0-6.22-5-7.72-10.36-4.6h0C75,50.57,70.61,58.14,70.61,64.37v1.14a5.27,5.27,0,0,0-4.54.7h0a15.53,15.53,0,0,0-7,12.17v.52l-5,2.87a10.25,10.25,0,0,0-4.62,8c0,2.95,2.07,4.15,4.62,2.67L94.3,69.24a10.24,10.24,0,0,0,4.63-8C98.93,58.27,96.86,57.07,94.3,58.55Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.39,356.71l34.94-20.2c3.6-2.08,5.4-4.81,5.4-7.53s0-4.86,0-4.86L223.5,303.68a7.7,7.7,0,0,1-3.48-6V260.39l-61,35.26v37.27a7.69,7.69,0,0,0,3.47,6l30.84,17.77C200.51,360.87,212.19,360.87,219.39,356.71Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.39,356.71l34.94-20.2c3.6-2.08,5.4-4.81,5.4-7.53s0-4.86,0-4.86L223.5,303.68a7.7,7.7,0,0,1-3.48-6V260.39l-61,35.26v37.27a7.69,7.69,0,0,0,3.47,6l30.84,17.77C200.51,360.87,212.19,360.87,219.39,356.71Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.65,340.54v4.84l-11.19-6.44a7.73,7.73,0,0,1-3.47-6V295.65l11.63-6.71c.24,2.95.5,6,.74,9l-8.15,4.72v27.84a7.65,7.65,0,0,0,3.47,6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.21,330.49a7.66,7.66,0,0,0,3.47,6l26.63,15.34c7.2,4.16,18.88,4.16,26.08,0l35-20.2c7.2-4.15,7.2-10.89,0-15l-26.64-15.35a7.68,7.68,0,0,1-3.48-6V267.38l-61,35.26Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.21,330.49a7.66,7.66,0,0,0,3.47,6l26.63,15.34c7.2,4.16,18.88,4.16,26.08,0l35-20.2c7.2-4.15,7.2-10.89,0-15l-26.64-15.35a7.68,7.68,0,0,1-3.48-6V267.38l-61,35.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,305.35h0l-7.08-4.09a7.68,7.68,0,0,1-3.48-6V267.38l-61,35.26v27.85a7.66,7.66,0,0,0,3.47,6l7,4Z",
    style: {
      fill: "#6B2DEE",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,305.35h0l-7.08-4.09a7.68,7.68,0,0,1-3.48-6V267.38l-61,35.26v27.85a7.66,7.66,0,0,0,3.47,6l7,4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.74,324.12V329c0,2.73-1.81,5.44-5.4,7.53L219.4,356.7A26.14,26.14,0,0,1,207,359.79V355a26.14,26.14,0,0,0,12.45-3.09l34.94-20.21C257.93,329.58,259.74,326.85,259.74,324.12Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.74,324.12V329c0,2.73-1.81,5.44-5.4,7.53L219.4,356.7A26.14,26.14,0,0,1,207,359.79V355a26.14,26.14,0,0,0,12.45-3.09l34.94-20.21C257.93,329.58,259.74,326.85,259.74,324.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22,372.33a9.32,9.32,0,0,0,8.43-.16l236-136.25a9.61,9.61,0,0,0,4.34-7.53V43.28a9.32,9.32,0,0,0-4.07-7.37,9.32,9.32,0,0,0-8.43.16L65.5,172.32a9.59,9.59,0,0,0-4.35,7.52V365A9.33,9.33,0,0,0,65.22,372.33Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22,372.33a9.32,9.32,0,0,0,8.43-.16l236-136.25a9.61,9.61,0,0,0,4.34-7.53V43.28a9.32,9.32,0,0,0-4.07-7.37,9.32,9.32,0,0,0-8.43.16L65.5,172.32a9.59,9.59,0,0,0-4.35,7.52V365A9.33,9.33,0,0,0,65.22,372.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.65,372.16l236-136.24a9.61,9.61,0,0,0,4.34-7.53V43.28c0-2.77-1.94-3.9-4.34-2.51L73.65,177a9.6,9.6,0,0,0-4.34,7.53v185.1C69.3,372.43,71.25,373.55,73.65,372.16Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.65,372.16l236-136.24a9.61,9.61,0,0,0,4.34-7.53V43.28c0-2.77-1.94-3.9-4.34-2.51L73.65,177a9.6,9.6,0,0,0-4.34,7.53v185.1C69.3,372.43,71.25,373.55,73.65,372.16Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,377.13a9.42,9.42,0,0,1-7.79-.16,9.35,9.35,0,0,1-4.08-7.39V358l8.16,4.72V374.3C69.3,376.83,70.9,378,73,377.13Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,377.13a9.42,9.42,0,0,1-7.79-.16,9.35,9.35,0,0,1-4.08-7.39V358l8.16,4.72V374.3C69.3,376.83,70.9,378,73,377.13Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,362.72v11.57c0,2.77,2,3.9,4.35,2.51l236-136.25A9.61,9.61,0,0,0,314,233V221.41Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,362.72v11.57c0,2.77,2,3.9,4.35,2.51l236-136.25A9.61,9.61,0,0,0,314,233V221.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46,340.91V187.25a5.76,5.76,0,0,1,2.61-4.51L303.22,53.9c1.45-.83,2.61-.16,2.61,1.5V209.06a5.76,5.76,0,0,1-2.61,4.52L80.07,342.42C78.63,343.25,77.46,342.57,77.46,340.91Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46,340.91V187.25a5.76,5.76,0,0,1,2.61-4.51L303.22,53.9c1.45-.83,2.61-.16,2.61,1.5V209.06a5.76,5.76,0,0,1-2.61,4.52L80.07,342.42C78.63,343.25,77.46,342.57,77.46,340.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.65,296.39a8,8,0,0,0-3.6,6.23c0,2.29,1.61,3.22,3.6,2.07a7.94,7.94,0,0,0,3.59-6.22C195.24,296.17,193.63,295.24,191.65,296.39Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.58,180.25a9.23,9.23,0,0,0-1.28,4.29V362.72L61.14,358V179.84a9,9,0,0,1,1.28-4.29Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.58,180.25a9.23,9.23,0,0,0-1.28,4.29V362.72L61.14,358V179.84a9,9,0,0,1,1.28-4.29Z",
    style: {
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ladder--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.09,160.4,366.48,273.64v0a1.46,1.46,0,0,1-.73.78,4.15,4.15,0,0,1-3.79,0,1.45,1.45,0,0,1-.78-.93,1.6,1.6,0,0,1,0-.31,2.82,2.82,0,0,1,.15-.78l41.73-113.87a2.68,2.68,0,1,1,5,1.85Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,160.4,366.48,273.64v0a1.46,1.46,0,0,1-.73.78,4.15,4.15,0,0,1-3.79,0,1.45,1.45,0,0,1-.78-.93,1.6,1.6,0,0,1,0-.31,2.82,2.82,0,0,1,.15-.78l41.73-113.87a2.68,2.68,0,1,1,5,1.85Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.33,
    y: 224.26,
    width: 6,
    height: 48.18,
    transform: "translate(-28.41 447.49) rotate(-60)",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 370.33,
    y: 224.26,
    width: 6,
    height: 48.18,
    transform: "translate(-28.41 447.49) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 400.68,
    y: 206.74,
    width: 6,
    height: 48.18,
    transform: "translate(1.93 465.02) rotate(-60)",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 400.68,
    y: 206.74,
    width: 6,
    height: 48.18,
    transform: "translate(1.93 465.02) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,152.62l22.25-12.85a5.87,5.87,0,0,1,9,4l36.94,172.82a1.49,1.49,0,0,1,.05.36,1.53,1.53,0,0,1,0,.37,1.44,1.44,0,0,1-.78.92,4.15,4.15,0,0,1-3.79,0,1.64,1.64,0,0,1-.74-.8.9.9,0,0,1,0-.16L400.13,144.89a.59.59,0,0,0-1.05-.47l-22.26,12.85",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,152.62l22.25-12.85a5.87,5.87,0,0,1,9,4l36.94,172.82a1.49,1.49,0,0,1,.05.36,1.53,1.53,0,0,1,0,.37,1.44,1.44,0,0,1-.78.92,4.15,4.15,0,0,1-3.79,0,1.64,1.64,0,0,1-.74-.8.9.9,0,0,1,0-.16L400.13,144.89a.59.59,0,0,0-1.05-.47l-22.26,12.85",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.45,317.78,396.9,310a1.78,1.78,0,0,1-.81-1.4v-.32a1.76,1.76,0,0,1,.81-1.4l32.52-18.78a1.78,1.78,0,0,1,1.62,0l13.55,7.83a1.76,1.76,0,0,1,.81,1.4v.32a1.78,1.78,0,0,1-.81,1.4l-32.52,18.78A1.84,1.84,0,0,1,410.45,317.78Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.33,307.43a1.61,1.61,0,0,0-.24.8v.32a1.78,1.78,0,0,0,.81,1.4l13.55,7.83a1.67,1.67,0,0,0,.81.19v-1.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,316.05V318a1.64,1.64,0,0,0,.81-.19l16.26-9.39L444.59,299a1.78,1.78,0,0,0,.81-1.4v-.32a1.61,1.61,0,0,0-.24-.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.58,290.29,391,282.47a1.79,1.79,0,0,1-.81-1.4v-.33a1.79,1.79,0,0,1,.81-1.4l32.52-18.77a1.78,1.78,0,0,1,1.62,0l13.55,7.82a1.79,1.79,0,0,1,.81,1.4v.33a1.79,1.79,0,0,1-.81,1.4l-32.52,18.77A1.76,1.76,0,0,1,404.58,290.29Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.45,280a1.61,1.61,0,0,0-.24.79v.33a1.79,1.79,0,0,0,.81,1.4l13.56,7.82a1.61,1.61,0,0,0,.8.2v-1.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.38,288.57v1.92a1.62,1.62,0,0,0,.81-.2l16.26-9.38,16.26-9.39a1.79,1.79,0,0,0,.81-1.4v-.33a1.61,1.61,0,0,0-.24-.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.7,262.81,385.14,255a1.79,1.79,0,0,1-.81-1.4v-.32a1.82,1.82,0,0,1,.81-1.4l32.52-18.77a1.78,1.78,0,0,1,1.62,0l13.56,7.82a1.81,1.81,0,0,1,.8,1.4v.32a1.81,1.81,0,0,1-.8,1.41l-32.52,18.77A1.78,1.78,0,0,1,398.7,262.81Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.57,252.46a1.64,1.64,0,0,0-.24.8v.32a1.79,1.79,0,0,0,.81,1.4l6.78,3.92,6.78,3.91a1.62,1.62,0,0,0,.81.19v-1.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.51,261.09V263a1.67,1.67,0,0,0,.81-.19l16.26-9.39L432.84,244a1.81,1.81,0,0,0,.8-1.41v-.32a1.67,1.67,0,0,0-.23-.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.82,235.33l-13.55-7.83a1.78,1.78,0,0,1-.81-1.4v-.32a1.78,1.78,0,0,1,.81-1.4l32.52-18.78a1.76,1.76,0,0,1,1.61,0L427,213.43a1.8,1.8,0,0,1,.81,1.4v.32a1.8,1.8,0,0,1-.81,1.4l-32.52,18.78A1.78,1.78,0,0,1,392.82,235.33Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.63,233.6v1.92a1.67,1.67,0,0,0,.81-.19l16.26-9.39L427,216.55a1.78,1.78,0,0,0,.81-1.4v-.32a1.64,1.64,0,0,0-.24-.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.69,225a1.74,1.74,0,0,0-.23.8v.32a1.78,1.78,0,0,0,.81,1.4l13.55,7.83a1.64,1.64,0,0,0,.81.19V233.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,207.85l-22.52-13a1.76,1.76,0,0,1-.81-1.4v-.32a1.78,1.78,0,0,1,.81-1.4l32.52-18.78a1.84,1.84,0,0,1,1.62,0l22.52,13a1.76,1.76,0,0,1,.81,1.4v.32a1.79,1.79,0,0,1-.81,1.4l-32.52,18.78A1.84,1.84,0,0,1,386.94,207.85Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.75,206.12V208a1.76,1.76,0,0,0,.81-.19l16.26-9.39,16.26-9.39a1.79,1.79,0,0,0,.81-1.4v-.32a1.61,1.61,0,0,0-.24-.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.85,192.32a1.64,1.64,0,0,0-.24.8v.32a1.78,1.78,0,0,0,.81,1.4l22.52,13a1.79,1.79,0,0,0,.81.19v-1.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.75,177.91,336.18,291v0l-.1.25a1.69,1.69,0,0,1-.67.66,4.24,4.24,0,0,1-3.8,0,1.44,1.44,0,0,1-.77-.94,1.5,1.5,0,0,1,0-.3,2.42,2.42,0,0,1,.16-.79l41.72-113.87a2.68,2.68,0,1,1,5,1.84Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.75,177.91,336.18,291v0l-.1.25a1.69,1.69,0,0,1-.67.66,4.24,4.24,0,0,1-3.8,0,1.44,1.44,0,0,1-.77-.94,1.5,1.5,0,0,1,0-.3,2.42,2.42,0,0,1,.16-.79l41.72-113.87a2.68,2.68,0,1,1,5,1.84Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.82,157.27a4.14,4.14,0,0,0-1.79,4L412,334.1a1.52,1.52,0,0,1,.06.42,1.5,1.5,0,0,1,0,.3,1.46,1.46,0,0,1-.78.94,4.15,4.15,0,0,1-3.79,0,1.69,1.69,0,0,1-.74-.77v0l-.05-.22-36.9-172.33a9.57,9.57,0,0,1,4.36-9.79",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,334.1,375,161.28a4.14,4.14,0,0,1,1.79-4l-2.68-4.65a9.57,9.57,0,0,0-4.36,9.79l36.9,172.33.05.22v0a1.69,1.69,0,0,0,.74.77,4.15,4.15,0,0,0,3.79,0,1.46,1.46,0,0,0,.78-.94,1.5,1.5,0,0,0,0-.3A1.52,1.52,0,0,0,412,334.1Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.85,76.71A1.07,1.07,0,0,1,344,77,1.07,1.07,0,0,0,343.85,76.71Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.11,77.11a2,2,0,0,1,.11.35A2,2,0,0,0,344.11,77.11Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,363.17v-153a6.27,6.27,0,0,1,2.84-4.92L341.5,76.62a2,2,0,0,1,2-.2c-.54-.32-3.52-2-4-2.34a2,2,0,0,0-2.09.15L114.73,202.82a6.3,6.3,0,0,0-2.84,4.92v153a2,2,0,0,0,.83,1.84l4.06,2.34h0A1.91,1.91,0,0,1,116,363.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,205.37a5.58,5.58,0,0,0-.62,2.37v23.07l4.06,2.34h0v-23a5.58,5.58,0,0,1,.63-2.41Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,205.37a5.58,5.58,0,0,0-.62,2.37v23.07l4.06,2.34h0v-23a5.58,5.58,0,0,1,.63-2.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,205.21,341.5,76.62a2,2,0,0,1,2-.2c-.54-.32-3.52-2-4-2.34a2,2,0,0,0-2.09.15L114.73,202.82a6,6,0,0,0-2.22,2.55l4.08,2.35h0A5.92,5.92,0,0,1,118.8,205.21Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,205.21,341.5,76.62a2,2,0,0,1,2-.2c-.54-.32-3.52-2-4-2.34a2,2,0,0,0-2.09.15L114.73,202.82a6,6,0,0,0-2.22,2.55l4.08,2.35h0A5.92,5.92,0,0,1,118.8,205.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,78.24v153a6.28,6.28,0,0,1-2.84,4.92L118.8,364.79c-1.58.84-2.85.11-2.84-1.64v-153a6.27,6.27,0,0,1,2.84-4.92L341.5,76.6C343.07,75.69,344.34,76.43,344.34,78.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,76.42h0a1.08,1.08,0,0,1,.2.16A1.46,1.46,0,0,0,343.51,76.42Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.28,77.63a3.06,3.06,0,0,1,.06.63A3.06,3.06,0,0,0,344.28,77.63Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5,76.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.22,77.46a1.15,1.15,0,0,1,.06.17A1.15,1.15,0,0,0,344.22,77.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,77a.49.49,0,0,1,.1.15A.49.49,0,0,0,344,77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.7,76.58c.05,0,.11.08.15.13S343.75,76.63,343.7,76.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,78.26v10L116,220.13v-10a6.27,6.27,0,0,1,2.84-4.92L341.5,76.62C343.07,75.71,344.34,76.45,344.34,78.26Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,88.26v13L116,233.15v-13l4.26-2.47c1.14-.66,1.52-1.66,2.06-3.58l1.45-5c.45-1.74.92-2.93,2.07-3.59L175.17,177c1.15-.66,2-.73,2.91.71l1.77,3.22c.65,1.12,1,1.78,2.12,1.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.3,83.63c1.22-.71,2.21-.14,2.21,1.27a4.9,4.9,0,0,1-2.21,3.83c-1.22.7-2.21.13-2.21-1.28A4.86,4.86,0,0,1,336.3,83.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.35,88.21c1.22-.7,2.21-.13,2.21,1.27a4.9,4.9,0,0,1-2.21,3.83c-1.22.7-2.21.13-2.21-1.28A4.88,4.88,0,0,1,328.35,88.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,92.79c1.22-.7,2.21-.13,2.21,1.28a4.86,4.86,0,0,1-2.21,3.82c-1.22.71-2.21.14-2.21-1.27A4.9,4.9,0,0,1,320.4,92.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,221.1,122.2,223l1.24-2.39a.57.57,0,0,0,0-.58c-.09-.11-.26,0-.37.18l-1.76,3.39h0a.61.61,0,0,0,0,.12s0,0,0,0a.47.47,0,0,0,0,.17.33.33,0,0,0,0,.15v0a.13.13,0,0,0,0,.07h0l1.76,1.36a.19.19,0,0,0,.18,0,.65.65,0,0,0,.17-.81l-1.24-.95,3.25-1.88a.69.69,0,0,0,.26-.55C125.71,221.13,125.59,221,125.45,221.1Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16,219.53l3.25-1.87-1.24-1c-.11-.08-.12-.33,0-.55s.26-.33.37-.25l1.76,1.35h0a.43.43,0,0,1,0,.07l0,0a.61.61,0,0,1,0,.15,1.11,1.11,0,0,1,0,.17s0,0,0,0,0,.09,0,.13h0l-1.76,3.39a.5.5,0,0,1-.17.2.15.15,0,0,1-.2,0,.59.59,0,0,1,0-.59l1.24-2.38-3.25,1.88c-.14.08-.26,0-.26-.25A.71.71,0,0,1,128.16,219.53Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.82,210.18c0-.2-.19-.18-.28,0l-.44,1.09c-.76-.09-1.68.65-2.3,2-.8,1.7-.8,3.72,0,4.49a1.15,1.15,0,0,0,1.46.09,4,4,0,0,0,1.46-1.77.57.57,0,0,0,0-.57c-.1-.1-.27,0-.37.21-.6,1.27-1.58,1.84-2.18,1.26s-.6-2.08,0-3.36c.43-.9,1-1.44,1.58-1.47l-.34.82c-.08.21,0,.41.13.32l1.33-.86a.45.45,0,0,0,.15-.37Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.74,183.12l1.19-2.51a.76.76,0,0,0,0-.78c-.14-.13-.37,0-.51.29l-1.18,2.51-1.19-1.14c-.14-.13-.36,0-.5.29a.76.76,0,0,0,0,.78l1.18,1.14-1.18,2.51a.76.76,0,0,0,0,.78.2.2,0,0,0,.25,0,.74.74,0,0,0,.25-.31l1.19-2.51,1.18,1.14a.2.2,0,0,0,.25,0,.68.68,0,0,0,.26-.31.76.76,0,0,0,0-.78Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13,213.26v-4.19a4.59,4.59,0,0,1,2.07-3.59l185.42-107c1.14-.66,2.07-.13,2.07,1.19v4.19a4.57,4.57,0,0,1-2.07,3.58l-185.42,107C144.06,215.11,143.13,214.58,143.13,213.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.8,107.78a.41.41,0,0,1-.19,0,.57.57,0,0,1-.32-.64l.2-1.69-.79-.57a.56.56,0,0,1-.22-.47.93.93,0,0,1,.34-.74l1.22-.94s0,0,0-.08l.54-1.79a.77.77,0,0,1,.63-.59.49.49,0,0,1,.49.3l.45,1,1-.39a.5.5,0,0,1,.57.13.76.76,0,0,1,0,.85l-.88,1.65.18,1.59a1,1,0,0,1-.26.76.62.62,0,0,1-.5.19l-1-.12-1.07,1.36A.64.64,0,0,1,327.8,107.78Zm-.56-3.48.78.57a.59.59,0,0,1,.22.58l-.13,1.08.69-.87a.62.62,0,0,1,.56-.27l1,.12a.19.19,0,0,0,0-.09l-.21-1.49a1,1,0,0,1,.11-.55L331,102l-.75.28a.5.5,0,0,1-.65-.26l-.34-.72-.48,1.54a.89.89,0,0,1-.3.47l-1.22.93A.59.59,0,0,0,327.24,104.3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.35,98.07a.67.67,0,0,1-.36-1.25l5.41-3.24a.67.67,0,0,1,.69,1.15L335.68,98A.58.58,0,0,1,335.35,98.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.31,101.18a.67.67,0,0,1-.34-1.25l5.47-3.16a.66.66,0,0,1,.91.25.67.67,0,0,1-.24.92l-5.46,3.15A.72.72,0,0,1,335.31,101.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.31,104.34a.68.68,0,0,1-.58-.34.67.67,0,0,1,.24-.92l5.47-3.15a.66.66,0,0,1,.91.24.67.67,0,0,1-.24.92l-5.46,3.16A.72.72,0,0,1,335.31,104.34Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "115.95 220.13 111.89 217.78 111.89 230.81 115.95 233.15 115.95 220.13",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.63,117.37a1.59,1.59,0,0,0-1.44.2L128.29,237a4.78,4.78,0,0,0-2.16,3.75v9.07a1.56,1.56,0,0,0,.59,1.38c-.37-.24-3.64-2.09-4-2.33a1.54,1.54,0,0,1-.62-1.39v-9.07a4.78,4.78,0,0,1,2.17-3.75L331.12,115.22a1.56,1.56,0,0,1,1.55-.15C333,115.29,335.86,116.9,336.63,117.37Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,237,335.19,117.57c1.2-.7,2.17-.14,2.17,1.25v9.07a4.78,4.78,0,0,1-2.17,3.75L128.3,251.09c-1.2.69-2.17.13-2.17-1.25v-9.07A4.78,4.78,0,0,1,128.3,237Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77,238.63l-4.07-2.34a4.45,4.45,0,0,0-.64,2.14v9.07a1.54,1.54,0,0,0,.62,1.39c.4.24,3.67,2.09,4,2.33a1.56,1.56,0,0,1-.59-1.38v-9.07A4.48,4.48,0,0,1,126.77,238.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.63,117.37c-.77-.47-3.61-2.08-4-2.3a1.56,1.56,0,0,0-1.55.15L124.23,234.68a4.4,4.4,0,0,0-1.53,1.61l4.07,2.34a4.38,4.38,0,0,1,1.52-1.61l206.9-119.45A1.59,1.59,0,0,1,336.63,117.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23,128a4.65,4.65,0,0,1-2.16,3.6L274.53,162c-1.2.69-2.17.2-2.17-1.1a4.64,4.64,0,0,1,2.17-3.59L327.07,127C328.26,126.26,329.23,126.75,329.23,128Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,200.3,333.65,145c.91-.52,1.65-.15,1.65.84a3.56,3.56,0,0,1-1.65,2.74l-95.84,55.34c-.91.53-1.65.16-1.65-.83A3.54,3.54,0,0,1,237.81,200.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,207.45l95.84-55.35c.91-.52,1.65-.15,1.65.84a3.54,3.54,0,0,1-1.65,2.74L237.81,211c-.91.53-1.65.16-1.65-.83A3.54,3.54,0,0,1,237.81,207.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,214.6l95.84-55.35c.91-.52,1.65-.15,1.65.84a3.54,3.54,0,0,1-1.65,2.74l-95.84,55.35c-.91.52-1.65.15-1.65-.84A3.54,3.54,0,0,1,237.81,214.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.23,260l93.16-53.79c1.19-.69,2.16-.13,2.16,1.25V291.6a4.8,4.8,0,0,1-2.16,3.75l-93.16,53.8c-1.2.69-2.17.13-2.17-1.25V263.78A4.78,4.78,0,0,1,124.23,260Z",
    style: {
      fill: "#e6e6e6",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.46,273.84a5.4,5.4,0,0,0-.63-1,4.89,4.89,0,0,0-.37-.41,4.18,4.18,0,0,0-1.16-.85,3.89,3.89,0,0,0-.66-.29,5.5,5.5,0,0,0-2-.26,6.1,6.1,0,0,0-.72.08l-.52.1-.51.13c-.19.06-.38.12-.58.2l-.51.2a5.46,5.46,0,0,1,0,.58v.07c0,.11,0,.22,0,.34s0,.23,0,.35c0,6.17-4.34,13.68-9.68,16.77a11.1,11.1,0,0,1-1.18.61h0a4,4,0,0,0,.07.5,1.55,1.55,0,0,0,0,.21,5.23,5.23,0,0,0,.12.54,2.75,2.75,0,0,0,.14.49,4,4,0,0,0,.18.52,4.08,4.08,0,0,0,.19.42,5.24,5.24,0,0,0,.67,1.07,4.91,4.91,0,0,0,.75.76l.08.06.35.25.07,0a3.75,3.75,0,0,0,.44.24l.5.2a6.07,6.07,0,0,0,3.74-.06,11.68,11.68,0,0,0,1.11-.41c.38-.17.76-.37,1.15-.59,5.35-3.09,9.69-10.59,9.69-16.77A9.07,9.07,0,0,0,165.46,273.84Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.21,263l-1,2a1.39,1.39,0,0,0,.08,1.24,11.4,11.4,0,0,1,1.13,2.52.61.61,0,0,0,.85.4l5.1-2.3a.54.54,0,0,1,.41,0Zm-6.31-10.75-3.7-2.14a.74.74,0,0,0-.26,0,2,2,0,0,0-.24,0,.23.23,0,0,0-.14,0,1.12,1.12,0,0,0-.24.19s-.1,0-.13.09l-3,4.53-3.81-2.2-.08,0-2.76-1.59h0a.35.35,0,0,0-.14,0,.55.55,0,0,0-.29.08l-3.94,2.28-.45.26h0l-1.24.71-.08,0a1.24,1.24,0,0,0-.22.18,1.82,1.82,0,0,0-.36.54h0a1.1,1.1,0,0,0-.1.34l-.58,6.38a.36.36,0,0,1,0,.1,1.07,1.07,0,0,1-.09.34,2.11,2.11,0,0,1-.48.75,34.07,34.07,0,0,0-3.19,3.37,1.17,1.17,0,0,1-1.13.32l-3.67-1.29a.82.82,0,0,0-.27,0l-.08,0-.08,0-.07,0-.14,0-.15.08a.34.34,0,0,0-.12.09.51.51,0,0,0-.13.16l-1.73,3-1.83,3.17-.65,1.13a.83.83,0,0,0-.1.56h0a.83.83,0,0,0,.27.51l3,2.55a1.07,1.07,0,0,1,.14.16,1.13,1.13,0,0,1,.2.59,1.21,1.21,0,0,1-.06.38,34,34,0,0,0-1.32,4.44,2,2,0,0,1-.35.71,1.92,1.92,0,0,1-.39.41l-5.23,3.68a1.07,1.07,0,0,0-.19.18,2.71,2.71,0,0,0-.17.25h0a1.45,1.45,0,0,0-.23.7v6.62a.47.47,0,0,0,.2.42l6.64,3.84-2.42,4.88a.76.76,0,0,0,.3,1l9,5.23.12,0-.11-.06-.6-.35a.78.78,0,0,1-.31-1l3.41-6.86a.77.77,0,0,0,.08-.27,1.48,1.48,0,0,0-.16-1,11.71,11.71,0,0,1-1.14-2.53.61.61,0,0,0-.85-.4l-2.57,1.16-2.53,1.14a.45.45,0,0,1-.45,0h0a.46.46,0,0,1-.19-.42v-6.62a1.37,1.37,0,0,1,.22-.7,1.24,1.24,0,0,1,.36-.42l5.24-3.69a1.83,1.83,0,0,0,.38-.4,2,2,0,0,0,.35-.71,33.56,33.56,0,0,1,1.33-4.44,1.15,1.15,0,0,0,.06-.37h0a1.07,1.07,0,0,0-.35-.76l-2.95-2.54a.95.95,0,0,1-.19-1.09l1.2-2.08,1.49-2.58,1.53-2.64a.82.82,0,0,1,.65-.4h0a.66.66,0,0,1,.37,0l3.68,1.28a1,1,0,0,0,.66,0,1,1,0,0,0,.47-.31,35.2,35.2,0,0,1,3.18-3.37,2.06,2.06,0,0,0,.48-.74,1.68,1.68,0,0,0,.12-.45l.57-6.38a.88.88,0,0,1,.1-.34,1.44,1.44,0,0,1,.59-.73l1.08-.62,2.31-1.34L159.5,256a.49.49,0,0,1,.43-.05l0,0a.45.45,0,0,1,.23.39l.29,2.92.27,2.65a.61.61,0,0,0,.76.54,10.74,10.74,0,0,1,2.76-.28,1.41,1.41,0,0,0,.8-.26,1.27,1.27,0,0,0,.31-.3l4.24-6.37a.64.64,0,0,1,.13-.15.77.77,0,0,1,.67-.17.44.44,0,0,1,.16.06ZM153.2,311a.35.35,0,0,1-.08-.13.59.59,0,0,1-.05-.19l-.55-5.56a.6.6,0,0,0-.77-.54,11.65,11.65,0,0,1-2.76.28,1.42,1.42,0,0,0-1.11.55l-1.22,1.83,6.55,3.78S153.21,311,153.2,311Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.58,255a.44.44,0,0,0-.16-.06.77.77,0,0,0-.67.17.64.64,0,0,0-.13.15l-4.24,6.37a1.27,1.27,0,0,1-.31.3,1.41,1.41,0,0,1-.8.26,10.74,10.74,0,0,0-2.76.28.61.61,0,0,1-.76-.54l-.27-2.65-.29-2.92A.45.45,0,0,0,160,256l0,0a.49.49,0,0,0-.43.05l-2.34,1.35-2.31,1.34-1.08.62a1.44,1.44,0,0,0-.59.73.88.88,0,0,0-.1.34l-.57,6.38a1.68,1.68,0,0,1-.12.45,2.06,2.06,0,0,1-.48.74,35.2,35.2,0,0,0-3.18,3.37,1,1,0,0,1-.47.31,1,1,0,0,1-.66,0l-3.68-1.28a.66.66,0,0,0-.37,0h0a.82.82,0,0,0-.65.4l-1.53,2.64L139.87,276l-1.2,2.08a.95.95,0,0,0,.19,1.09l2.95,2.54a1.07,1.07,0,0,1,.35.76h0a1.15,1.15,0,0,1-.06.37,33.56,33.56,0,0,0-1.33,4.44,2,2,0,0,1-.35.71,1.83,1.83,0,0,1-.38.4l-5.24,3.69a1.24,1.24,0,0,0-.36.42,1.37,1.37,0,0,0-.22.7v6.62a.46.46,0,0,0,.19.42h0a.45.45,0,0,0,.45,0l2.53-1.14,2.57-1.16a.61.61,0,0,1,.85.4,11.71,11.71,0,0,0,1.14,2.53,1.48,1.48,0,0,1,.16,1,.77.77,0,0,1-.08.27l-3.41,6.86a.78.78,0,0,0,.31,1l.6.35.11.06-.12,0-9-5.23a.76.76,0,0,1-.3-1l2.42-4.88L126,295.35a.47.47,0,0,1-.2-.42v-6.62a1.45,1.45,0,0,1,.23-.7h0a2.71,2.71,0,0,1,.17-.25,1.07,1.07,0,0,1,.19-.18l5.23-3.68a1.92,1.92,0,0,0,.39-.41,2,2,0,0,0,.35-.71,34,34,0,0,1,1.32-4.44,1.21,1.21,0,0,0,.06-.38,1.13,1.13,0,0,0-.2-.59,1.07,1.07,0,0,0-.14-.16l-3-2.55a.83.83,0,0,1-.27-.51h0a.83.83,0,0,1,.1-.56l.65-1.13,1.83-3.17.5-.87,1.27-2.2a.77.77,0,0,1,.93-.34l.06,0h0l3.37,1.19h0l.29.1a1.17,1.17,0,0,0,1.13-.32,34.07,34.07,0,0,1,3.19-3.37,2.11,2.11,0,0,0,.48-.75,1.07,1.07,0,0,0,.09-.34.36.36,0,0,0,0-.1l.58-6.38a1.1,1.1,0,0,1,.1-.34h0a1.82,1.82,0,0,1,.36-.54,1.33,1.33,0,0,1,.3-.23l1.24-.71h0l.45-.26,3.94-2.28a.55.55,0,0,1,.29-.08.35.35,0,0,1,.14,0h0l2.76,1.59.08,0,3.81,2.2,3-4.53c0-.05.09-.05.13-.09a1.12,1.12,0,0,1,.24-.19.23.23,0,0,1,.14,0,2,2,0,0,1,.24,0,.74.74,0,0,1,.26,0l3.7,2.14Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.12,310.91a.59.59,0,0,1-.05-.19l-.55-5.56a.6.6,0,0,0-.77-.54,11.65,11.65,0,0,1-2.76.28,1.42,1.42,0,0,0-1.11.55l-1.22,1.83,6.55,3.78s0,0,0,0A.35.35,0,0,1,153.12,310.91Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.21,263l-1,2a1.39,1.39,0,0,0,.08,1.24,11.4,11.4,0,0,1,1.13,2.52.61.61,0,0,0,.85.4l5.1-2.3a.54.54,0,0,1,.41,0Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,260a.88.88,0,0,0-.1.34l-.57,6.38a1.68,1.68,0,0,1-.12.45L144,262.34h0a2.55,2.55,0,0,0,.11-.33.36.36,0,0,0,0-.1l.58-6.38a1.12,1.12,0,0,1,.11-.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,282.43l-8.43-4.87,0,0a1.18,1.18,0,0,0-.16-.57,1.07,1.07,0,0,0-.14-.16l-3-2.55a.83.83,0,0,1-.27-.51l8.43,4.87a.83.83,0,0,0,.27.51l2.95,2.54A1.07,1.07,0,0,1,142.16,282.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63,308.93a.78.78,0,0,0,.31,1l.6.35h0l-9-5.23a.76.76,0,0,1-.3-1l2.42-4.88,1.78,1h0a.45.45,0,0,0,.45,0l2.53-1.14,4.72,2.73a.77.77,0,0,1-.08.27Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2,311s0,0,0,0l-6.55-3.78,1.22-1.83a1.42,1.42,0,0,1,1.11-.55,11.65,11.65,0,0,0,2.76-.28.6.6,0,0,1,.77.54l.55,5.56a.59.59,0,0,0,.05.19A.35.35,0,0,0,153.2,311Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.32,278c0,6.18-4.34,13.68-9.69,16.77-.39.22-.77.42-1.15.59a11.68,11.68,0,0,1-1.11.41,6.07,6.07,0,0,1-3.74.06l-.5-.2a3.75,3.75,0,0,1-.44-.24l-.07,0-.35-.25-.08-.06a4.91,4.91,0,0,1-.75-.76,5.24,5.24,0,0,1-.67-1.07,4.08,4.08,0,0,1-.19-.42,4,4,0,0,1-.18-.52,2.75,2.75,0,0,1-.14-.49,5.23,5.23,0,0,1-.12-.54,1.55,1.55,0,0,1,0-.21,4,4,0,0,1-.07-.5h0a11.1,11.1,0,0,0,1.18-.61c5.34-3.09,9.68-10.6,9.68-16.77,0-.12,0-.23,0-.35s0-.23,0-.34v-.07a5.44,5.44,0,0,0-.05-.58h0l.51-.2c.2-.08.39-.14.58-.2l.51-.13.52-.1a6.1,6.1,0,0,1,.72-.08,5.5,5.5,0,0,1,2,.26,3.89,3.89,0,0,1,.66.29,4.18,4.18,0,0,1,1.16.85,4.89,4.89,0,0,1,.37.41,5.4,5.4,0,0,1,.63,1A9.07,9.07,0,0,1,166.32,278Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,266.84a.54.54,0,0,0-.41,0l-5.1,2.3a.61.61,0,0,1-.85-.4,11.4,11.4,0,0,0-1.13-2.52,1.39,1.39,0,0,1-.08-1.24l1-2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.58,255a.44.44,0,0,0-.16-.06.77.77,0,0,0-.67.17.93.93,0,0,0-.13.15l-4.24,6.37a1.27,1.27,0,0,1-.31.3l-2.37-1.37-2.22-1.28-.29-2.92A.45.45,0,0,0,160,256l0,0-1.75-1,3-4.53a.68.68,0,0,1,.37-.28.23.23,0,0,1,.14,0,.67.67,0,0,1,.5.07l3.7,2.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.42,288a1.83,1.83,0,0,1-.38.4l-5.24,3.69a1.24,1.24,0,0,0-.36.42L126,287.61l.17-.25a1.07,1.07,0,0,1,.19-.18l5.23-3.68a1.92,1.92,0,0,0,.39-.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,256h0l0,0Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,256h0l0,0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.05,273.91v-6.62a.43.43,0,0,0-.65-.42l-5.1,2.3a.61.61,0,0,1-.85-.39,11.5,11.5,0,0,0-1.14-2.53,1.42,1.42,0,0,1-.08-1.24l3.4-6.86a.76.76,0,0,0-.3-1L170.64,255a.76.76,0,0,0-1,.23l-4.24,6.38a1.42,1.42,0,0,1-1.11.55,11.65,11.65,0,0,0-2.76.28.61.61,0,0,1-.77-.54l-.56-5.57a.43.43,0,0,0-.69-.35l-5.73,3.31a1.5,1.5,0,0,0-.68,1.07l-.58,6.37a2,2,0,0,1-.59,1.19,34.26,34.26,0,0,0-3.19,3.38,1.09,1.09,0,0,1-1.12.31l-3.68-1.28a.91.91,0,0,0-1,.38l-4.21,7.3a.9.9,0,0,0,.18,1.09l3,2.54a1.1,1.1,0,0,1,.28,1.14,35.07,35.07,0,0,0-1.32,4.44,2.07,2.07,0,0,1-.74,1.11l-5.23,3.69a1.53,1.53,0,0,0-.59,1.13v6.61a.43.43,0,0,0,.65.43l5.11-2.3a.6.6,0,0,1,.85.39,11,11,0,0,0,1.13,2.53,1.39,1.39,0,0,1,.08,1.24l-3.4,6.85a.77.77,0,0,0,.3,1l3.69,2.13a.78.78,0,0,0,1-.24l4.24-6.37a1.39,1.39,0,0,1,1.11-.55,11.62,11.62,0,0,0,2.75-.28.61.61,0,0,1,.77.54l.56,5.57a.43.43,0,0,0,.69.35l5.73-3.31a1.59,1.59,0,0,0,.69-1.07l.57-6.38a2.19,2.19,0,0,1,.6-1.19,34,34,0,0,0,3.18-3.37,1.11,1.11,0,0,1,1.13-.32l3.68,1.29a.89.89,0,0,0,1-.39l4.21-7.3a.88.88,0,0,0-.18-1.08l-2.95-2.55a1.08,1.08,0,0,1-.29-1.13,35.63,35.63,0,0,0,1.33-4.44,2.06,2.06,0,0,1,.73-1.11l5.24-3.69A1.55,1.55,0,0,0,179.05,273.91Zm-22.41,20.82c-5.35,3.08-9.69.58-9.69-5.6s4.34-13.68,9.69-16.77,9.68-.58,9.68,5.59S162,291.64,156.64,294.73Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.05,273.91v-6.62a.43.43,0,0,0-.65-.42l-5.1,2.3a.61.61,0,0,1-.85-.39,11.5,11.5,0,0,0-1.14-2.53,1.42,1.42,0,0,1-.08-1.24l3.4-6.86a.76.76,0,0,0-.3-1L170.64,255a.76.76,0,0,0-1,.23l-4.24,6.38a1.42,1.42,0,0,1-1.11.55,11.65,11.65,0,0,0-2.76.28.61.61,0,0,1-.77-.54l-.56-5.57a.43.43,0,0,0-.69-.35l-5.73,3.31a1.5,1.5,0,0,0-.68,1.07l-.58,6.37a2,2,0,0,1-.59,1.19,34.26,34.26,0,0,0-3.19,3.38,1.09,1.09,0,0,1-1.12.31l-3.68-1.28a.91.91,0,0,0-1,.38l-4.21,7.3a.9.9,0,0,0,.18,1.09l3,2.54a1.1,1.1,0,0,1,.28,1.14,35.07,35.07,0,0,0-1.32,4.44,2.07,2.07,0,0,1-.74,1.11l-5.23,3.69a1.53,1.53,0,0,0-.59,1.13v6.61a.43.43,0,0,0,.65.43l5.11-2.3a.6.6,0,0,1,.85.39,11,11,0,0,0,1.13,2.53,1.39,1.39,0,0,1,.08,1.24l-3.4,6.85a.77.77,0,0,0,.3,1l3.69,2.13a.78.78,0,0,0,1-.24l4.24-6.37a1.39,1.39,0,0,1,1.11-.55,11.62,11.62,0,0,0,2.75-.28.61.61,0,0,1,.77.54l.56,5.57a.43.43,0,0,0,.69.35l5.73-3.31a1.59,1.59,0,0,0,.69-1.07l.57-6.38a2.19,2.19,0,0,1,.6-1.19,34,34,0,0,0,3.18-3.37,1.11,1.11,0,0,1,1.13-.32l3.68,1.29a.89.89,0,0,0,1-.39l4.21-7.3a.88.88,0,0,0-.18-1.08l-2.95-2.55a1.08,1.08,0,0,1-.29-1.13,35.63,35.63,0,0,0,1.33-4.44,2.06,2.06,0,0,1,.73-1.11l5.24-3.69A1.55,1.55,0,0,0,179.05,273.91Zm-22.41,20.82c-5.35,3.08-9.69.58-9.69-5.6s4.34-13.68,9.69-16.77,9.68-.58,9.68,5.59S162,291.64,156.64,294.73Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,266.59l-2-1.16a.8.8,0,0,0-.62.38l-1.26,2.2h0l-.51.87-1.83,3.17-.65,1.13a.83.83,0,0,0-.1.56h0l8.43,4.87a.83.83,0,0,1,.08-.58l1.2-2.08,1.49-2.58,1.53-2.64a.82.82,0,0,1,.65-.4Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,266.59l-2-1.16a.8.8,0,0,0-.62.38l-1.26,2.2h0l-.51.87-1.83,3.17-.65,1.13a.83.83,0,0,0-.1.56h0l8.43,4.87a.83.83,0,0,1,.08-.58l1.2-2.08,1.49-2.58,1.53-2.64a.82.82,0,0,1,.65-.4Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82,266.76a1,1,0,0,1-.65,0l-.28-.1h0l-3.38-1.19h0l-.07,0a.83.83,0,0,0-.31,0l.11.07h0l1.86,1.09.64.36h0l5.81,3.39h0a.66.66,0,0,1,.37,0l3.68,1.28a1,1,0,0,0,.66,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.93,256a.49.49,0,0,0-.43.05l-2.34,1.35-2.31,1.34-1.08.62a1.44,1.44,0,0,0-.59.73l-8.42-4.86h0a1.82,1.82,0,0,1,.36-.54,1.24,1.24,0,0,1,.22-.18l.08,0,1.24-.71h0l.45-.26,3.94-2.28a.55.55,0,0,1,.29-.08.35.35,0,0,1,.14,0h0l2.76,1.59.08,0,3.81,2.2Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.93,256a.49.49,0,0,0-.43.05l-2.34,1.35-2.31,1.34-1.08.62a1.44,1.44,0,0,0-.59.73l-8.42-4.86h0a1.82,1.82,0,0,1,.36-.54,1.24,1.24,0,0,1,.22-.18l.08,0,1.24-.71h0l.45-.26,3.94-2.28a.55.55,0,0,1,.29-.08.35.35,0,0,1,.14,0h0l2.76,1.59.08,0,3.81,2.2Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32,278.16a3.14,3.14,0,0,0-2.46-2h-.12l-.11,0h-.14a4.78,4.78,0,0,0-2.22.47c0,.27,0,.55,0,.85A13.87,13.87,0,0,1,192,288.4a7.59,7.59,0,0,1-.74.39,5,5,0,0,0,.43,1.64,3.15,3.15,0,0,0,3,2h.29l.33,0,.28-.05.12,0,.17,0a8.9,8.9,0,0,0,4.08-2.64C203.13,286.23,204.65,281.1,203.32,278.16Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.92,289.62a8.9,8.9,0,0,1-4.08,2.64l-.17,0-.12,0-.28.05-.33,0h-.29a3.15,3.15,0,0,1-3-2,5,5,0,0,1-.43-1.64,7.59,7.59,0,0,0,.74-.39,13.87,13.87,0,0,0,6.29-10.9c0-.3,0-.58,0-.85a4.78,4.78,0,0,1,2.22-.47h.14l.11,0h.12a3.14,3.14,0,0,1,2.46,2C204.65,281.1,203.13,286.23,199.92,289.62Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.79,298.51l-1.61-2.45c-.11-.17-.41-.16-.67,0s-.63.42-.94.6l3.25,1.88Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26,278.17q0,.61-.06,1.26a.44.44,0,0,0,.45.44l2.69.15a.42.42,0,0,1,.2.05Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.6,297.8a5.4,5.4,0,0,1-1.37-.8.56.56,0,0,0-.7.12l-3.2,2.93a.58.58,0,0,1-.35.16l3.14,1.81,1.94,1.13a.29.29,0,0,1-.13-.31l1-4.48A.5.5,0,0,0,190.6,297.8Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,300l.06,0,.19.11.05,0s-.06-.05-.07-.09l-1.43-3.15a.61.61,0,0,1,0-.38,1,1,0,0,1,.18-.37l3-3.63a1.41,1.41,0,0,0,.27-.55.74.74,0,0,0,0-.25,15,15,0,0,1,0-2.59.43.43,0,0,0-.45-.43l-2.69-.16a.35.35,0,0,1-.37-.45l1.48-5a1,1,0,0,1,.67-.56l2.94-.71a1.27,1.27,0,0,0,.75-.55,27.9,27.9,0,0,1,1.58-2.75,1.13,1.13,0,0,0,.11-.22.58.58,0,0,0,0-.14l0-.14a.64.64,0,0,0,0-.28l-1-3.24a.62.62,0,0,1,0-.37.72.72,0,0,1,.09-.2,1.33,1.33,0,0,1,.14-.19l3.44-3.63a.42.42,0,0,1,.46-.16h0a.2.2,0,0,1,.09.07l1.6,2.45c.11.17.41.16.67,0a14.4,14.4,0,0,1,1.94-1.12,1.53,1.53,0,0,0,.69-.66l1.69-4.56a.37.37,0,0,1,.07-.12.92.92,0,0,1,.43-.31l.08,0,.11,0,3.13-.32h.07l.12,0a.21.21,0,0,1,.11,0,.25.25,0,0,1,.13.31l-1,4.49a.51.51,0,0,0,.32.56,5.09,5.09,0,0,1,1.37.79.56.56,0,0,0,.7-.12l3.2-2.92c.17-.15.34-.2.46-.14l-6.31-3.66-.12,0-1.14-.66h0l-1.25-.72-.5-.29-1.13-.66-.18-.11-.88-.5a.48.48,0,0,0-.31-.06l-3.13.31a.35.35,0,0,0-.14,0l-.14.05-.14.08-.1.09a.57.57,0,0,0-.16.23l-1.7,4.55a.3.3,0,0,1-.06.11.83.83,0,0,1-.12.16l-.16.16,0,0-.14.1-.18.11c-.33.15-.65.33-1,.52l-3.29-1.9-.05,0a.3.3,0,0,0-.27,0,.46.46,0,0,0-.19.13h0l-2.44,2.57-1,1.06a1,1,0,0,0-.15.2,1.6,1.6,0,0,0-.1.23.61.61,0,0,0,0,.26s0,0,0,.06l1,3.24a.91.91,0,0,1,0,.29.44.44,0,0,1,0,.1v0s0,0,0,.05a1.09,1.09,0,0,1-.14.31,27.75,27.75,0,0,0-1.58,2.74,1.22,1.22,0,0,1-.74.56l-3,.71a.94.94,0,0,0-.66.55l-1.49,5a.33.33,0,0,0,.12.36l2.27,1.32,1.06.61c0,.46,0,.91.06,1.34v0a.75.75,0,0,1,0,.2,1,1,0,0,1-.07.23,2.46,2.46,0,0,1-.19.32l-3,3.64a1,1,0,0,0-.18.37.75.75,0,0,0,0,.2.47.47,0,0,0,0,.17l1.43,3.15a.24.24,0,0,0,.09.11h0l.9.52c.13.07.28.15.43.25l3.83,2.21.42.24.23.14",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,300l.06,0,.19.11.05,0s-.06-.05-.07-.09l-1.43-3.15a.61.61,0,0,1,0-.38,1,1,0,0,1,.18-.37l3-3.63a1.41,1.41,0,0,0,.27-.55.74.74,0,0,0,0-.25,15,15,0,0,1,0-2.59.43.43,0,0,0-.45-.43l-2.69-.16a.35.35,0,0,1-.37-.45l1.48-5a1,1,0,0,1,.67-.56l2.94-.71a1.27,1.27,0,0,0,.75-.55,27.9,27.9,0,0,1,1.58-2.75,1.13,1.13,0,0,0,.11-.22.58.58,0,0,0,0-.14l0-.14a.64.64,0,0,0,0-.28l-1-3.24a.62.62,0,0,1,0-.37.72.72,0,0,1,.09-.2,1.33,1.33,0,0,1,.14-.19l3.44-3.63a.42.42,0,0,1,.46-.16h0a.2.2,0,0,1,.09.07l1.6,2.45c.11.17.41.16.67,0a14.4,14.4,0,0,1,1.94-1.12,1.53,1.53,0,0,0,.69-.66l1.69-4.56a.37.37,0,0,1,.07-.12.92.92,0,0,1,.43-.31l.08,0,.11,0,3.13-.32h.07l.12,0a.21.21,0,0,1,.11,0,.25.25,0,0,1,.13.31l-1,4.49a.51.51,0,0,0,.32.56,5.09,5.09,0,0,1,1.37.79.56.56,0,0,0,.7-.12l3.2-2.92c.17-.15.34-.2.46-.14l-6.31-3.66-.12,0-1.14-.66h0l-1.25-.72-.5-.29-1.13-.66-.18-.11-.88-.5a.48.48,0,0,0-.31-.06l-3.13.31a.35.35,0,0,0-.14,0l-.14.05-.14.08-.1.09a.57.57,0,0,0-.16.23l-1.7,4.55a.3.3,0,0,1-.06.11.83.83,0,0,1-.12.16l-.16.16,0,0-.14.1-.18.11c-.33.15-.65.33-1,.52l-3.29-1.9-.05,0a.3.3,0,0,0-.27,0,.46.46,0,0,0-.19.13h0l-2.44,2.57-1,1.06a1,1,0,0,0-.15.2,1.6,1.6,0,0,0-.1.23.61.61,0,0,0,0,.26s0,0,0,.06l1,3.24a.91.91,0,0,1,0,.29.44.44,0,0,1,0,.1v0s0,0,0,.05a1.09,1.09,0,0,1-.14.31,27.75,27.75,0,0,0-1.58,2.74,1.22,1.22,0,0,1-.74.56l-3,.71a.94.94,0,0,0-.66.55l-1.49,5a.33.33,0,0,0,.12.36l2.27,1.32,1.06.61c0,.46,0,.91.06,1.34v0a.75.75,0,0,1,0,.2,1,1,0,0,1-.07.23,2.46,2.46,0,0,1-.19.32l-3,3.64a1,1,0,0,0-.18.37.75.75,0,0,0,0,.2.47.47,0,0,0,0,.17l1.43,3.15a.24.24,0,0,0,.09.11h0l.9.52c.13.07.28.15.43.25l3.83,2.21.42.24.23.14",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.79,298.51l-1.61-2.45c-.11-.17-.41-.16-.67,0s-.63.42-.94.6l3.25,1.88Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26,278.17q0,.61-.06,1.26a.44.44,0,0,0,.45.44l2.69.15a.42.42,0,0,1,.2.05Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.6,297.8a5.4,5.4,0,0,1-1.37-.8.56.56,0,0,0-.7.12l-3.2,2.93a.58.58,0,0,1-.35.16l3.14,1.81,1.94,1.13a.29.29,0,0,1-.13-.31l1-4.48A.5.5,0,0,0,190.6,297.8Z",
    style: {
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.72,292.21a1.45,1.45,0,0,1-.2.34l-3,3.63a1,1,0,0,0-.18.37L177,292.89a1,1,0,0,1,.18-.37l3-3.64a2.46,2.46,0,0,0,.19-.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.81,291.75a.92.92,0,0,1-.09.46l-6.33-3.65a1,1,0,0,0,.07-.23.75.75,0,0,0,0-.2v0c0-.43-.06-.87-.06-1.33l3,1.71a.47.47,0,0,0,.28.1l2.69.16a.43.43,0,0,1,.45.43A15,15,0,0,0,186.81,291.75Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.8,281.68a1.05,1.05,0,0,1-.4.19l-2.94.71a1.06,1.06,0,0,0-.54.35l-6.34-3.65a1,1,0,0,1,.33-.28l.22-.08,3-.71a1.2,1.2,0,0,0,.38-.18h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,288.12a.34.34,0,0,0,.09.35l-3-1.71h0l-3.26-1.89-.05,0a.32.32,0,0,1-.12-.36l1.49-5a.58.58,0,0,1,.1-.19l6.35,3.65a.6.6,0,0,0-.13.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.65,270.56l6.33,3.63a.57.57,0,0,0,0,.36l1,3.24a.87.87,0,0,1,0,.42l-6.33-3.66v0s0-.07,0-.1a.91.91,0,0,0,0-.29l-1-3.24a.51.51,0,0,1,0-.32",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,265.94a.6.6,0,0,0-.17.23l-1.69,4.56a1.07,1.07,0,0,1-.34.42l-6.33-3.66a1.17,1.17,0,0,0,.28-.32.3.3,0,0,0,.06-.11l1.7-4.55a.57.57,0,0,1,.16-.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,288.12a.34.34,0,0,0,.09.35l-3-1.71h0l-3.26-1.89-.05,0a.32.32,0,0,1-.12-.36l1.49-5a.58.58,0,0,1,.1-.19l6.35,3.65a.6.6,0,0,0-.13.21Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,288.12a.34.34,0,0,0,.09.35l-3-1.71h0l-3.26-1.89-.05,0a.32.32,0,0,1-.12-.36l1.49-5a.58.58,0,0,1,.1-.19l6.35,3.65a.6.6,0,0,0-.13.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.58,279.28l0,0,0,0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16,270h0a.42.42,0,0,0-.49.15l-3.44,3.63a1.25,1.25,0,0,0-.24.4l-6.33-3.63a1.09,1.09,0,0,1,.09-.23,1,1,0,0,1,.15-.2l3.44-3.63a.77.77,0,0,1,.19-.14.3.3,0,0,1,.27,0h.05l3.29,1.9Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16,270h0a.42.42,0,0,0-.49.15l-3.44,3.63a1.25,1.25,0,0,0-.24.4l-6.33-3.63a1.09,1.09,0,0,1,.09-.23,1,1,0,0,1,.15-.2l3.44-3.63a.77.77,0,0,1,.19-.14.3.3,0,0,1,.27,0h.05l3.29,1.9Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.93,265.43a.5.5,0,0,0-.28-.05l-3.13.32a.87.87,0,0,0-.52.24l-6.33-3.66.1-.09.14-.08.14-.05a.58.58,0,0,1,.14,0l3.13-.31a.48.48,0,0,1,.31.06Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.93,265.43a.5.5,0,0,0-.28-.05l-3.13.32a.87.87,0,0,0-.52.24l-6.33-3.66.1-.09.14-.08.14-.05a.58.58,0,0,1,.14,0l3.13-.31a.48.48,0,0,1,.31.06Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25,286.65l.18.1h0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,280.07a.42.42,0,0,0-.2-.05l-2.69-.15a.44.44,0,0,1-.45-.44q.06-.65.06-1.26a11.65,11.65,0,0,0,0-1.33,1.23,1.23,0,0,1,.29-.79l3-3.64a.78.78,0,0,0,.18-.74l-1.42-3.15a.18.18,0,0,0-.09-.1h0c-.12-.06-.29,0-.46.14l-3.2,2.92a.56.56,0,0,1-.7.12,5.09,5.09,0,0,0-1.37-.79.51.51,0,0,1-.32-.56l1-4.49a.25.25,0,0,0-.13-.31.48.48,0,0,0-.3-.06l-3.13.32a.86.86,0,0,0-.69.47l-1.69,4.56a1.53,1.53,0,0,1-.69.66,14.4,14.4,0,0,0-1.94,1.12c-.26.18-.56.19-.67,0l-1.6-2.45c-.12-.17-.38-.14-.58.08l-3.44,3.63a.91.91,0,0,0-.27.76l1,3.24a1.06,1.06,0,0,1-.18.78,27.9,27.9,0,0,0-1.58,2.75,1.27,1.27,0,0,1-.75.55l-2.94.71a1,1,0,0,0-.67.56l-1.48,5a.35.35,0,0,0,.37.45l2.69.16a.43.43,0,0,1,.45.43,15,15,0,0,0,0,2.59,1.22,1.22,0,0,1-.29.8l-3,3.63a.85.85,0,0,0-.18.75l1.4,3.13a.14.14,0,0,0,.06.07.08.08,0,0,0,0,0h0l.12,0a.53.53,0,0,0,.35-.16l3.2-2.93a.56.56,0,0,1,.7-.12,5.4,5.4,0,0,0,1.37.8.5.5,0,0,1,.32.56l-1,4.48a.29.29,0,0,0,.13.31s0,0,0,0a.56.56,0,0,0,.3,0l3.13-.31a.9.9,0,0,0,.69-.48l1.7-4.55a1.43,1.43,0,0,1,.68-.67c.33-.15.67-.33,1-.52s.63-.38.94-.6.56-.19.67,0l1.61,2.45a.19.19,0,0,0,.07.08.42.42,0,0,0,.5-.16l3.45-3.63a.92.92,0,0,0,.26-.75l-1-3.24a1.13,1.13,0,0,1,.18-.79,26.93,26.93,0,0,0,1.58-2.74,1.24,1.24,0,0,1,.75-.56l2.94-.71a1,1,0,0,0,.67-.55l1.48-5a.33.33,0,0,0-.16-.39Zm-11.62,9.55a8.9,8.9,0,0,1-4.08,2.64l-.17,0-.12,0-.28.05-.33,0h-.29a3.15,3.15,0,0,1-3-2,5,5,0,0,1-.43-1.64,5.43,5.43,0,0,1-.05-.91A14.1,14.1,0,0,1,195.1,279a10.67,10.67,0,0,1,2.38-1.92,5.87,5.87,0,0,1,.79-.4,4.78,4.78,0,0,1,2.22-.47h.14l.11,0h.12a3.14,3.14,0,0,1,2.46,2C204.65,281.1,203.13,286.23,199.92,289.62Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,280.07a.42.42,0,0,0-.2-.05l-2.69-.15a.44.44,0,0,1-.45-.44q.06-.65.06-1.26a11.65,11.65,0,0,0,0-1.33,1.23,1.23,0,0,1,.29-.79l3-3.64a.78.78,0,0,0,.18-.74l-1.42-3.15a.18.18,0,0,0-.09-.1h0c-.12-.06-.29,0-.46.14l-3.2,2.92a.56.56,0,0,1-.7.12,5.09,5.09,0,0,0-1.37-.79.51.51,0,0,1-.32-.56l1-4.49a.25.25,0,0,0-.13-.31.48.48,0,0,0-.3-.06l-3.13.32a.86.86,0,0,0-.69.47l-1.69,4.56a1.53,1.53,0,0,1-.69.66,14.4,14.4,0,0,0-1.94,1.12c-.26.18-.56.19-.67,0l-1.6-2.45c-.12-.17-.38-.14-.58.08l-3.44,3.63a.91.91,0,0,0-.27.76l1,3.24a1.06,1.06,0,0,1-.18.78,27.9,27.9,0,0,0-1.58,2.75,1.27,1.27,0,0,1-.75.55l-2.94.71a1,1,0,0,0-.67.56l-1.48,5a.35.35,0,0,0,.37.45l2.69.16a.43.43,0,0,1,.45.43,15,15,0,0,0,0,2.59,1.22,1.22,0,0,1-.29.8l-3,3.63a.85.85,0,0,0-.18.75l1.4,3.13a.14.14,0,0,0,.06.07.08.08,0,0,0,0,0h0l.12,0a.53.53,0,0,0,.35-.16l3.2-2.93a.56.56,0,0,1,.7-.12,5.4,5.4,0,0,0,1.37.8.5.5,0,0,1,.32.56l-1,4.48a.29.29,0,0,0,.13.31s0,0,0,0a.56.56,0,0,0,.3,0l3.13-.31a.9.9,0,0,0,.69-.48l1.7-4.55a1.43,1.43,0,0,1,.68-.67c.33-.15.67-.33,1-.52s.63-.38.94-.6.56-.19.67,0l1.61,2.45a.19.19,0,0,0,.07.08.42.42,0,0,0,.5-.16l3.45-3.63a.92.92,0,0,0,.26-.75l-1-3.24a1.13,1.13,0,0,1,.18-.79,26.93,26.93,0,0,0,1.58-2.74,1.24,1.24,0,0,1,.75-.56l2.94-.71a1,1,0,0,0,.67-.55l1.48-5a.33.33,0,0,0-.16-.39Zm-11.62,9.55a8.9,8.9,0,0,1-4.08,2.64l-.17,0-.12,0-.28.05-.33,0h-.29a3.15,3.15,0,0,1-3-2,5,5,0,0,1-.43-1.64,5.43,5.43,0,0,1-.05-.91A14.1,14.1,0,0,1,195.1,279a10.67,10.67,0,0,1,2.38-1.92,5.87,5.87,0,0,1,.79-.4,4.78,4.78,0,0,1,2.22-.47h.14l.11,0h.12a3.14,3.14,0,0,1,2.46,2C204.65,281.1,203.13,286.23,199.92,289.62Z",
    style: {
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.38,219l93.16-53.79c1.2-.69,2.17-.13,2.17,1.25v84.11a4.78,4.78,0,0,1-2.17,3.75l-93.16,53.8c-1.19.69-2.16.13-2.16-1.25V222.74A4.8,4.8,0,0,1,266.38,219Z",
    style: {
      fill: "#37474f",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.86,220.61l-4.07-2.35a4.48,4.48,0,0,0-.64,2.14v84.11a1.54,1.54,0,0,0,.62,1.39c.4.24,3.67,2.09,4,2.33a1.56,1.56,0,0,1-.59-1.38V222.74A4.45,4.45,0,0,1,264.86,220.61Z",
    style: {
      fill: "#263238",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,165c-.77-.47-3.61-2.08-4-2.29a1.53,1.53,0,0,0-1.55.14l-93.16,53.8a4.32,4.32,0,0,0-1.53,1.61l4.07,2.35a4.49,4.49,0,0,1,1.52-1.62l93.17-53.79A1.59,1.59,0,0,1,361,165Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6,255a4.15,4.15,0,0,1,.29-1.66,11.4,11.4,0,0,1,.85-1.56l14.8-24a1.73,1.73,0,0,1,.26-.3,1,1,0,0,1,.17-.14.48.48,0,0,1,.6,0,1.07,1.07,0,0,1,.23.77v8.33a4.13,4.13,0,0,1-.43,1.89c-.29.57-.57,1.07-.83,1.51l-7,11.18,7,3.16a4.94,4.94,0,0,1,.83.55,1.75,1.75,0,0,1,.43,1.39v8.33a2.58,2.58,0,0,1-.23,1.05,1.56,1.56,0,0,1-.6.7.51.51,0,0,1-.17.07.57.57,0,0,1-.26,0l-14.8-6.89a2.19,2.19,0,0,1-.85-.57,2.1,2.1,0,0,1-.29-1.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.38,210.37a8.36,8.36,0,0,1,.59-1.59,2.8,2.8,0,0,1,1.14-1.24l4.9-2.82a.47.47,0,0,1,.61,0,1.06,1.06,0,0,1,.26.79,2.92,2.92,0,0,1-.08.59L310.5,263a7.21,7.21,0,0,1-.56,1.53,2.86,2.86,0,0,1-1.18,1.3L304,268.59a.48.48,0,0,1-.62,0,1.06,1.06,0,0,1-.25-.79,2.35,2.35,0,0,1,.08-.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.33,219a4.33,4.33,0,0,1-.29,1.66,11.35,11.35,0,0,1-.85,1.55l-14.8,24a2.31,2.31,0,0,1-.26.3.89.89,0,0,1-.18.13.45.45,0,0,1-.59,0,1,1,0,0,1-.24-.77v-8.33a4.11,4.11,0,0,1,.44-1.89c.29-.57.56-1.07.83-1.51l6.94-11.18-6.94-3.16a4.18,4.18,0,0,1-.83-.56,1.73,1.73,0,0,1-.44-1.39v-8.32a2.44,2.44,0,0,1,.24-1,1.55,1.55,0,0,1,.59-.7.58.58,0,0,1,.18-.08.79.79,0,0,1,.26,0l14.8,6.89a1.6,1.6,0,0,1,1.14,1.89Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.13,226.93a1.59,1.59,0,0,0-1.44.2l-93.17,53.79a4.8,4.8,0,0,0-2.16,3.75v84.11a1.56,1.56,0,0,0,.59,1.38c-.37-.24-3.64-2.09-4-2.33a1.54,1.54,0,0,1-.62-1.39V282.33a4.78,4.78,0,0,1,2.17-3.75l93.16-53.8a1.53,1.53,0,0,1,1.55-.14C250.52,224.85,253.36,226.46,254.13,226.93Z",
    style: {
      fill: "#6B2DEE",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,280.92l93.16-53.79c1.2-.69,2.17-.13,2.17,1.25v84.11a4.78,4.78,0,0,1-2.17,3.75L159.52,370c-1.19.69-2.16.13-2.16-1.25V284.67A4.8,4.8,0,0,1,159.52,280.92Z",
    style: {
      fill: "#6B2DEE",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,282.54l-4.07-2.35a4.48,4.48,0,0,0-.64,2.14v84.11a1.54,1.54,0,0,0,.62,1.39c.4.24,3.67,2.09,4,2.33a1.56,1.56,0,0,1-.59-1.38V284.67A4.45,4.45,0,0,1,158,282.54Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,226.93c-.77-.47-3.61-2.08-4-2.29a1.53,1.53,0,0,0-1.55.14l-93.16,53.8a4.4,4.4,0,0,0-1.53,1.61l4.07,2.35a4.49,4.49,0,0,1,1.52-1.62l93.17-53.79A1.59,1.59,0,0,1,254.13,226.93Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,308.82l7.36,10.35-33.27-30.28-35.07,59.4v20.5c0,1.38,1,1.94,2.16,1.25l93.16-53.8a4.78,4.78,0,0,0,2.17-3.75V301.23L230,283.37Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,259c4.35-2.51,7.87-.47,7.87,4.54a17.38,17.38,0,0,1-7.87,13.63c-4.34,2.51-7.86.47-7.86-4.54A17.4,17.4,0,0,1,222.35,259Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.65,227.83c.19,0,.2.49.2.55v84.11a3.81,3.81,0,0,1-1.67,2.89L159,369.17a.92.92,0,0,1-.46.16c-.2,0-.2-.49-.2-.54V284.67a3.81,3.81,0,0,1,1.66-2.88L253.18,228a1,1,0,0,1,.47-.16m0-1a2,2,0,0,0-1,.3l-93.16,53.79a4.8,4.8,0,0,0-2.16,3.75v84.12c0,1,.49,1.54,1.2,1.54a1.92,1.92,0,0,0,1-.29l93.16-53.8a4.78,4.78,0,0,0,2.17-3.75V228.38c0-1-.49-1.55-1.2-1.55Z",
    style: {
      fill: "#6B2DEE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wrench--inject-331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.52,409.06c-1.74,1-5,.95-6,2.14v4.29l19.9-2.91,7.53,4.41-2.86,6L202,421.63v4.28q.63.45,1.35.87c8.4,4.92,22.14,5,30.67.13,4.31-2.45,6.46-5.67,6.46-8.9h0v-4.27l-1.18.19-.14-.24,75.32-43.48c7.62,1.61,16.49.67,22.67-2.84,3.2-1.82,5.21-4.06,6-6.42v-4.29l-19.9,7.19-7.53-4.41,2.86-6,20.1-2.94v-4.29s-23.49-1.56-32,3.29a13.93,13.93,0,0,0-5.32,4.92l-1.14-.42v4.26h0a7.92,7.92,0,0,0,1.3,4.47l-75.31,43.48C218.57,404.62,209.69,405.55,203.52,409.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.43 370.21 314.43 365.92 239.12 409.4 239.11 413.69 314.43 370.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.51,358.46l-75.32,43.48c-7.62-1.61-16.5-.68-22.67,2.83-3.2,1.82-5.21,4.07-6,6.43l19.9-2.91,7.53,4.41-2.86,6L202,421.63c.42.29.87.58,1.35.86,8.4,4.93,22.14,5,30.67.14,6.26-3.56,8-8.76,5.15-13.23l75.31-43.48c7.62,1.61,16.5.68,22.67-2.83,3.2-1.82,5.21-4.07,6-6.43l-19.9,2.91-7.53-4.41,2.86-6,20.1-2.95c-.42-.29-.87-.58-1.35-.86-8.4-4.93-22.14-5-30.67-.14C300.39,348.79,298.68,354,301.51,358.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.31 356.09 315.71 355.15 318.57 349.18 338.67 346.23 338.67 350.52 318.57 353.46 317.31 356.09",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-331"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "403.78 105.62 405.62 115.81 415.83 116.32 413.47 102.78 403.78 105.62",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.25,90.78a9.14,9.14,0,0,1,.83-8.8c3.52-5.46,10.72-8.17,18.69-6,4,1.08,9,5.18,9.46,14.71.3,5.86-16,10.09-15.65,14.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.89,93s-2.24,3.54-1.93,3.9a5.57,5.57,0,0,0,1.79.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.77,82.6c-2.22,1.21-5,3.22-5.26,11-.23,8.55,1,11.09,2.2,12.18.8.73,5,.65,7.09-.05,2.62-.87,8.5-3.32,11.07-7.76,3-5.22,3.53-12.1-.15-14.71C410.53,79.59,402.65,81.58,400.77,82.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.61,82.56s-3.58,7.76,4.1,12.22c0,0,1.3-3,3.92-2.24s2.47,4.31.45,6.13-3.14.67-3.14.67a8,8,0,0,0,2.62,5.43,12.39,12.39,0,0,0,14.84-3.3c6.13-6.84,5.06-18.85-4.26-21.73S398.61,82.56,398.61,82.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.74,113.92h0a10.37,10.37,0,0,1-11-9.67L424.54,86.5h0a10.36,10.36,0,0,1,11,9.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,255.66l-.27-8.83,7.32-1.26.42,7.53c.35,1.76,1.6,2.33,1.91,3.32s-5,11.09-8,13.33-7.81-.63-8.29-1.71,4-.27,4.71-1.81C426.76,264.15,428,255.66,428,255.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12,254.57c-1,.8-1.7,2.82-3,5.59s-3.22,7.27-5.27,7.91c-2.4.74-7.1-.62-4.1-.85.66-.05,1.8-.3,2.11-1a5.75,5.75,0,0,0,.29-.77,9.18,9.18,0,0,1-3.2.3c-1.84-.08-3.2.34-4.16,1.79-.5.75.3,2,.3,2,.91,1.13,2.63,2.24,6.57,2.54s6.28-.28,7.69-3c1.72-3.24,4.76-6.69,6-8.52C440.79,258.4,438.41,255.16,436.12,254.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,265.62c-.24.61-2,.79-2.84.91s-1.27.91.13,1.36C425.73,268.15,426.92,265.58,426,265.62Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.85,110.06c3.08-.61,6.42,2.87,8.07,5.67s9.85,17.41,10.76,19.87,1.19,3-1.95,6.22S425.3,154,425.3,154l-3.44-7.06,8.78-9.93-9.76-14.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21,110s3.29-.75,5,.35a19.26,19.26,0,0,1,5.86,6.87c2,3.56,6.87,12.48,6.87,12.48a11.74,11.74,0,0,1-8.45,6.16l-6.42-8.22Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.21,110s3.29-.75,5,.35a19.26,19.26,0,0,1,5.86,6.87c2,3.56,6.87,12.48,6.87,12.48a11.74,11.74,0,0,1-8.45,6.16l-6.42-8.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.63,249.45s-4.44,2-8.24,1.19c0,0-3.38-12.17-7-26.59-3.65-14.66-7.52-31.64-8.29-40.49-1-12,1.56-28.37,3.31-37.44.79-4.15,1.41-6.79,1.41-6.79l5.62-.62c1.46,2.07,3,4,4.52,6a34.08,34.08,0,0,1,5.84,10.55l0,.11c3.89,12.81-3.05,37.64-3.68,47.51a24,24,0,0,1,4.28,11.72C433.92,218.66,435.63,249.45,435.63,249.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.16,264.44l-.27-8.82,7.32-1.27.42,7.53c.35,1.76,1.6,2.33,1.91,3.32s-5,11.1-8,13.33-7.81-.63-8.29-1.71,4-.27,4.71-1.81C409,272.93,410.16,264.44,410.16,264.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.28,263.35c-1,.8-1.71,2.82-3,5.59s-3.21,7.27-5.27,7.91c-2.39.75-7.09-.62-4.09-.85.65-.05,1.8-.3,2.1-1a4.31,4.31,0,0,0,.29-.77,9.09,9.09,0,0,1-3.19.3c-1.84-.08-3.2.34-4.16,1.79-.5.75.3,2,.3,2,.91,1.13,2.63,2.24,6.57,2.55,3.79.29,6.27-.29,7.69-3,1.71-3.25,4.75-6.7,6-8.52C422.94,267.19,420.56,263.94,418.28,263.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,274.4c-.24.61-2,.79-2.84.91s-1.27.92.13,1.37C407.94,276.94,409.13,274.36,408.23,274.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.83,155.27c-.79,4.77-2.95,10-10.45,14.2-1.33,14.59-4.39,28-5,37a22.14,22.14,0,0,1,3.34,9.85c.05,1-.09,3.89-.34,7.76-.78,12.28-2.58,34.19-2.58,34.19s-4.43,1.95-8.24,1.19c0,0-8-53.44-10.28-70.9a178.9,178.9,0,0,1-.84-38.1l17-4.31,11.55-1.4A34.08,34.08,0,0,1,432.83,155.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.67,138.71c0-.08.86-5.88,1.71-11.13,1.37-8.36-4.34-17.5-4.53-17.52a56,56,0,0,0-7.1.09s-.11,1.39-3,1.95a13.44,13.44,0,0,1-6.89-.38c-.54,0-6.81.49-5.42.39.07.51-5.13,12.49-5.13,12.49a7.76,7.76,0,0,0-.2,8.78,10.77,10.77,0,0,0,2.87,3.07c.45,3.27.85,6.15.85,6.15L397.78,159s7.57,1.93,19.92-.43c10.45-2,13.94-7.08,13.94-7.08Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.46,112.11c-6.66.36-6.31.83-14.75,6.11-7.88,4.92-15.41,9.15-15.41,9.15l-21.25-6.24A5.17,5.17,0,0,1,345.8,119c-1.26-2.09-2.78-2.81-4.38-4.39-1.26-1.23-1.56-2.27-2-2.12a2,2,0,0,0-.94,2.55,14.13,14.13,0,0,0,1.54,3,20.09,20.09,0,0,1-4.95-3.1c-3.5-2.94-6.08-4.34-6.22,1.5-.09,3.66,2.91,7.82,10.94,10.69,2.31.83,5.9,1.38,8.93,2.62h0c7.81,3.43,19.41,8.29,21.85,8.05,1.75-.17,25.63-11.19,25.63-11.19A17.09,17.09,0,0,0,399.46,112.11Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,112a18,18,0,0,0-10,1.94c-5.37,2.79-16,9.81-16,9.81s.89,9.05,5,10.88l17.87-7.5S404.24,119.93,401,112Z",
    style: {
      fill: "#6B2DEE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,112a18,18,0,0,0-10,1.94c-5.37,2.79-16,9.81-16,9.81s.89,9.05,5,10.88l17.87-7.5S404.24,119.93,401,112Z",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCreation);
export default __webpack_public_path__ + "static/media/product-creation.5d7981b92a8712111ef6f79634e322be.svg";
export { ForwardRef as ReactComponent };